export default __webpack_public_path__ + "static/media/title-menu-amorim-cork-flooring.ec1e1179.png";